(function () {
  'use strict';
  function init() {
  const configNode = document.getElementById('aura-easify-config');
  if (!configNode || document.getElementById('aura-easify-preview')) return true;
  const config = JSON.parse(configNode.textContent);
  const text = {...config.text,create:'Create my preview',approve:'Add to cart',change:'Request a change',offline:'Your artwork studio is unavailable. Please try again shortly.'};
  if(config.completion)text.photoRequired='Please add one clear photo above.';
  if(config.originalLayout){text.photoRequired='Please add all '+config.photoCount+' photos above.';text.fileError='Please use JPG, PNG or WebP photos under 20 MB each.';}
  if(config.productKey==='birthday'){text.photoRequired='Please add one photo of you together above.';text.prompt='Change your photo or birthday date above.';}
  let form = document.querySelector('main form[action$="/cart/add"]');
  if (!form) return false;
  let section = form.closest('.shopify-section') || document.querySelector('main');
  function findUploadWidget(){return section.querySelector(config.originalLayout?'.aep-original-inputs':'.po-productPageOptions-root');}
  let standaloneRemove = null;
  if(config.originalLayout)window.AuraOriginal.prepare(config,section,form);
  if (config.standaloneUpload && !section.querySelector('.po-productPageOptions-root input[type="file"]')) {
    const upload = document.createElement('div');
    upload.className = 'po-productPageOptions-root aep-private-upload';
    upload.innerHTML = '<div class="po-option-root" data-option-id="aura-private-photo"><div class="po-fileUpload-root"><div class="po-field-root"><div class="po-label-root"><label class="po-label-label"><span>Upload your image</span><span class="po-label-required"> *</span></label></div><label class="aep-private-dropzone" data-upload-field><input type="file" name="files" accept="image/jpeg,image/png,image/webp" hidden><span>Add files</span></label></div></div></div>';
    form.parentElement.insertBefore(upload, form);
    standaloneRemove = document.createElement('button');
    standaloneRemove.type = 'button'; standaloneRemove.className = 'aep-private-remove';
    standaloneRemove.textContent = '×'; standaloneRemove.setAttribute('aria-label', 'Remove photo');
    standaloneRemove.addEventListener('click', () => {
      invalidate(); files = []; uploadedSource = null;
      upload.querySelector('input[type="file"]').value = '';
      showFiles(); scheduleDraftSave();
    });
  }
  const mount = document.createElement('section');
  mount.id = 'aura-easify-preview';
  mount.setAttribute('data-artwork-ready', 'false');
  mount.setAttribute('aria-label', text.heading);
  const filesRow = document.createElement('div');
  filesRow.className = 'aep-files';
  const changePhoto = document.createElement('button');
  changePhoto.type = 'button';
  changePhoto.className = 'aep-secondary aep-change-photo';
  changePhoto.textContent = 'Change';
  changePhoto.setAttribute('aria-label', 'Change photo');
  changePhoto.hidden = true;
  const replacementInput = document.createElement('input');
  replacementInput.type = 'file';
  replacementInput.accept = 'image/jpeg,image/png,image/webp';
  replacementInput.hidden = true;
  replacementInput.setAttribute('aria-label', 'Choose a replacement photo');


  const create = document.createElement('button');
  create.type = 'button';
  create.className = 'aep-primary';
  create.textContent = text.create;
  const status = document.createElement('p');
  status.className = 'aep-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  const waiting = document.createElement('div');
  waiting.className = 'aep-waiting';
  waiting.hidden = true;
  const waitingPhoto = document.createElement('img');
  waitingPhoto.alt = 'Your uploaded photo';
  const waitingLabel = document.createElement('span');
  waitingLabel.className = 'aep-waiting-label';
  waitingLabel.textContent = 'Your photo';
  const activity = document.createElement('div');
  activity.className = 'aep-activity';
  activity.setAttribute('aria-hidden', 'true');
  waiting.append(waitingPhoto, waitingLabel, activity);
  const results = document.createElement('div');
  results.className = 'aep-results';
  results.hidden = true;
  const resumeBox = document.createElement('div');
  resumeBox.className = 'aep-resume';
  resumeBox.hidden = true;
  const resumeTitle = document.createElement('p');
  resumeTitle.textContent = 'Your saved artwork';
  const continueDraft = document.createElement('button');
  continueDraft.type = 'button';
  continueDraft.className = 'aep-secondary';
  continueDraft.textContent = 'Continue your artwork';
  const startOver = document.createElement('button');
  startOver.type = 'button';
  startOver.className = 'aep-draft-start';
  startOver.textContent = 'Start over';
  resumeBox.append(resumeTitle, continueDraft, startOver);
  const saveStatus = document.createElement('p');
  saveStatus.className = 'aep-save-status';
  saveStatus.setAttribute('role', 'status');
  const heading = document.createElement('h3');
  heading.textContent = text.heading;
  const canvas = document.createElement('canvas');
  canvas.setAttribute('role', 'img');
  canvas.setAttribute('aria-label', text.heading);
  const optionsSlot = document.createElement('div');
  optionsSlot.className = 'aep-options';
  optionsSlot.id = 'aep-entry-options';
  optionsSlot.setAttribute('aria-label', 'Choose your frame and size');
  const finishOptions = document.createElement('button');
  finishOptions.type = 'button';
  finishOptions.className = 'aep-finish-options';
  finishOptions.textContent = 'Done';
  finishOptions.hidden = true;
  finishOptions.addEventListener('click', () => {
    optionsSlot.hidden = true;
    results.scrollIntoView({behavior:'smooth',block:'start'});
    editOptions.focus({preventScroll:true});
  });
  const selectionRow = document.createElement('div');
  selectionRow.className = 'aep-selection-row';
  const selectionCopy = document.createElement('span');
  const editOptions = document.createElement('button');
  editOptions.type = 'button';
  editOptions.className = 'aep-edit-options';
  editOptions.textContent = 'Change';
  editOptions.setAttribute('aria-label', 'Change frame and size');
  editOptions.addEventListener('click', () => {
    optionsSlot.hidden = false;
    optionsSlot.scrollIntoView({behavior:'smooth', block:'center'});
    const first = optionsSlot.querySelector('input:checked, select, button');
    first?.focus({preventScroll:true});
  });
  selectionRow.append(selectionCopy, editOptions);
  const approve = document.createElement('button');
  approve.type = 'button';
  approve.className = 'aep-primary aep-approve';
  approve.textContent = text.approve;
  approve.disabled = true;
  const viewWall = document.createElement('button');
  viewWall.type = 'button';
  viewWall.className = 'aep-secondary aep-view-wall';
  viewWall.disabled = true;
  viewWall.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M8 5l1.5-2h5L16 5h4a2 2 0 0 1 2 2v13H2V7a2 2 0 0 1 2-2z"/><circle cx="12" cy="12" r="4"/></svg><span>View on your wall</span>';
  viewWall.addEventListener('click', () => {
    if (!image || busy) return;
    const wall = roomGuide()?.querySelector('aura-wall-preview');
    if (wall) wall.openDirectAR(viewWall);
    else status.textContent = 'Wall preview is loading. Please try again.';
  });
  const refine = document.createElement('details');
  const summary = document.createElement('summary');
  summary.textContent = text.change;
  const prompt = document.createElement('textarea');
  prompt.maxLength = 500;
  prompt.rows = 3;
  prompt.setAttribute('aria-label', text.prompt);
  prompt.placeholder = text.prompt;
  const regenerate = document.createElement('button');
  regenerate.type = 'button';
  regenerate.className = 'aep-secondary aep-regenerate';
  regenerate.textContent = text.another;
  regenerate.setAttribute('aria-label', text.another);
  refine.append(summary, prompt, regenerate);
  if(config.originalLayout){prompt.hidden=true;regenerate.hidden=true;const edit=document.createElement('button');edit.type='button';edit.className='aep-secondary';edit.textContent='Change photos or details';edit.addEventListener('click',()=>section.querySelector('.aep-original-inputs')?.scrollIntoView({behavior:'smooth',block:'center'}));refine.append(edit);}
  if(config.productKey==='birthday'){
    prompt.hidden=true;regenerate.hidden=true;
    const help=document.createElement('p');help.textContent='Change your photo or birthday date, then create a new preview. Your original faces are preserved.';
    const replace=document.createElement('button');replace.type='button';replace.className='aep-secondary';replace.textContent='Change photo';replace.addEventListener('click',()=>changePhoto.click());
    const changeDate=document.createElement('button');changeDate.type='button';changeDate.className='aep-secondary';changeDate.textContent='Change date';changeDate.addEventListener('click',()=>{const field=section.querySelector('.po-productPageOptions-root input[placeholder="MM/DD/YYYY (e.g., 12/25/2025)"]');field?.scrollIntoView({behavior:'smooth',block:'center'});field?.focus({preventScroll:true});});
    refine.append(help,replace,changeDate);
  }
  results.append(heading, canvas, selectionRow, viewWall, approve, refine);
  mount.append(resumeBox, filesRow);
  mount.append(changePhoto, replacementInput, create, waiting, status, results, saveStatus);
  form.parentElement.insertBefore(mount, form);
  let files = [], urls = [], revision = 0, busy = false, proof = null, image = null;
  let policy = null, variants = [], submission = null;
  let checkoutEnabled = false, cartBusy = false, cartPermit = null, cartAdded = false;
  let wallToken = '', wallRenderKey = '', wallRenderURL = '', handoffImage = null;
  let waitingUrl = '';
  let restoringDraft = false, offeringDraft = false, savedDraft = null, draftVersion = 0;
  let replacingPhoto = false;
  changePhoto.addEventListener('click', () => {
    if (busy || cartBusy || replacingPhoto) return;
    replacementInput.value = '';
    replacementInput.click();
  });
  replacementInput.addEventListener('change', async () => {
    const file = replacementInput.files?.[0];
    if (!file || busy || cartBusy || replacingPhoto) return;
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 20 * 1024 * 1024) {
      status.textContent = text.fileError;
      return;
    }
    const widget = findUploadWidget();
    const input = widget?.querySelector('input[type="file"]');
    if (!input) { status.textContent = text.fileError; return; }
    // Validate and prepare the new file before touching Easify's current upload.
    const transfer = new DataTransfer();
    transfer.items.add(file);
    replacingPhoto = true;
    create.disabled = true;
    syncUploadControl();
    try {
      invalidate();
      const removed = new Promise((resolve, reject) => {
        const check = () => {
          if (!widget.querySelector('.po-fileUpload-uploadItem')) {
            observer.disconnect(); clearTimeout(timeout); resolve();
          }
        };
        const observer = new MutationObserver(check);
        const timeout = setTimeout(() => { observer.disconnect(); reject(Error(text.fileError)); }, 5000);
        observer.observe(widget, {childList:true, subtree:true});
        widget.querySelectorAll('.po-fileUpload-uploadRemove').forEach(button => button.click());
        check();
      });
      await removed;
      const currentInput = widget.querySelector('input[type="file"]');
      if (!currentInput) throw Error(text.fileError);
      currentInput.files = transfer.files;
      currentInput.dispatchEvent(new Event('change', {bubbles:true}));
    } catch (error) { status.textContent = error.message; }
    finally {
      replacingPhoto = false;
      create.disabled = busy;
      syncUploadControl();
    }
  });
  const endpoint = config.apiBase;
  const validEndpoint = endpoint && endpoint.startsWith('/') && !endpoint.startsWith('//') && !endpoint.includes('..');
  const variantsNode = document.getElementById('aura-easify-variants');
  if (variantsNode) variants = JSON.parse(variantsNode.textContent).map(v => ({id: String(v.id), options: Array.isArray(v.options) ? {'Frame Style': v.options[0], 'Frame Color': v.options[1], Size: v.options[2]} : v.options}));
  function variant() {
    const current = document.querySelector('main form[action$="/cart/add"]');
    if (current && current !== form) { form=current; section=form.closest('.shopify-section') || document.querySelector('main'); }
    const id = form.querySelector('[name="id"]')?.value;
    return variants.find(v => String(v.id) === String(id));
  }
  function invalidate() {
    mount.setAttribute('data-artwork-ready', 'false');
    revision++;
    proof = image = submission = null;
    results.hidden = true;
    optionsSlot.hidden = false;
    create.hidden = offeringDraft || restoringDraft;
    approve.disabled = true;
    cartPermit = null;
    cartAdded = false;
    wallToken = ''; wallRenderKey = ''; handoffImage = null;
    roomGuide()?.setCustomArtwork?.(null);
    status.textContent = '';
  }
  function showFiles() {
    if(config.originalLayout){window.AuraOriginal.showFiles(filesRow,files,next=>{if(busy||cartBusy)return;invalidate();files=next;showFiles();scheduleDraftSave();},config.productKey);syncUploadControl();return;}
    urls.forEach(url => URL.revokeObjectURL(url));
    urls = [];
    filesRow.replaceChildren();
    files.forEach(file => {
      const row = document.createElement('div');
      row.className = 'aep-file';
      const thumb = document.createElement('img');
      thumb.src = URL.createObjectURL(file);
      urls.push(thumb.src);
      thumb.alt = '';
      thumb.width = thumb.height = 56;
      const name = document.createElement('span');
      name.textContent = file.name;
      row.append(thumb, name);
      filesRow.append(row);
    });
    syncUploadControl();
  }
  function syncUploadControl() {
    const widget = findUploadWidget();
    if (!widget) return;
    const input = widget.querySelector('input[type="file"]');
    if (input) input.multiple = !!config.originalLayout && config.photoCount>1;
    if(config.originalLayout){const label=widget.querySelector('[data-upload-field]');if(label)label.hidden=files.length>=config.photoCount;filesRow.hidden=!files.length;changePhoto.hidden=true;return;}
    const items = widget.querySelectorAll('.po-fileUpload-uploadItem');
    const label = widget.querySelector('[data-upload-field]');
    const hide = items.length > 0 || files.length > 0;
    if (label && label.hidden !== hide) label.hidden = hide;
    filesRow.hidden = items.length > 0;
    const photoRow = items[0] || filesRow.querySelector('.aep-file');
    if (photoRow && changePhoto.parentElement !== photoRow) photoRow.append(changePhoto);
    else if (!photoRow && changePhoto.parentElement !== mount) mount.insertBefore(changePhoto, create);
    changePhoto.hidden = !hide;
    if (standaloneRemove) {
      standaloneRemove.hidden = !hide;
      standaloneRemove.disabled = busy || cartBusy || restoringDraft;
      if (photoRow && standaloneRemove.parentElement !== photoRow) photoRow.append(standaloneRemove);
    }
    changePhoto.disabled = busy || cartBusy || replacingPhoto || restoringDraft || !!widget.querySelector('[role="status"]');
  }
  function lock(value) {
    busy = value;
    mount.setAttribute('data-artwork-ready', String(!value && !!image));
    create.disabled = value || restoringDraft;
    create.hidden = !value && !!image;
    regenerate.disabled = value;
    prompt.disabled = value;
    syncUploadControl();
    create.textContent = value ? 'Preparing your photo…' : text.create;
    create.setAttribute('aria-live', 'polite');
    mount.setAttribute('aria-busy', String(value));
    waiting.hidden = !value;
    if (waitingUrl) URL.revokeObjectURL(waitingUrl);
    waitingUrl = '';
    if (value) {
      results.hidden = true;
      waitingPhoto.hidden=!files.length;
      if(files.length){waitingUrl = URL.createObjectURL(files[0]);waitingPhoto.src = waitingUrl;}
    } else {
      waitingPhoto.src = '';
      if (image) results.hidden = false;
    }
  }
  function showPhase(job) {
    create.textContent = job.status === 'queued' ? 'Waiting for the studio…' : 'Creating your artwork…';
  }
  function readFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(Error(text.fileError));
      reader.readAsDataURL(file);
    });
  }
  // App proxies strip cookies. Persist the opaque capability only for an opted-in saved draft.
  let sessionToken = '', sessionInFlight = null;
  const sessionKey = 'aura-preview-session:' + endpoint;
  const draftKey = 'aura-artwork-draft-v1:' + config.handle;
  let draftStorage = false;
  try { if (typeof localStorage !== 'undefined') { localStorage.setItem(draftKey + ':check', '1'); localStorage.removeItem(draftKey + ':check'); draftStorage = true; } } catch (_) {}
  try { sessionToken = sessionStorage.getItem(sessionKey) || ''; } catch (_) {}
  async function session() {
    if (sessionToken) return sessionToken;
    if (sessionInFlight) return sessionInFlight;
    sessionInFlight = createSession();
    try { return await sessionInFlight; }
    finally { sessionInFlight = null; }
  }
  async function createSession() {
    const response = await fetch(endpoint + '/api/session', {method: 'POST', credentials: 'same-origin',
      headers: {'X-Aura-Preview': '1'}});
    if (!response.headers.get('content-type')?.includes('application/json')) throw Error(text.offline);
    const data = await response.json();
    if (!response.ok || !data.token) throw Error(data.error || text.offline);
    sessionToken = data.token;
    try { sessionStorage.setItem(sessionKey, sessionToken); } catch (_) {}
    return sessionToken;
  }
  async function authorized(path, options = {}) {
    const response = await fetch(endpoint + path, {...options, credentials: 'same-origin',
      headers: {...options.headers, 'X-Aura-Session': await session(), 'X-Aura-Product': config.productKey}});
    if (response.status === 401) {
      sessionToken = '';
      try { sessionStorage.removeItem(sessionKey); } catch (_) {}
      // Never retry a paid generation implicitly.
    }
    return response;
  }
  async function json(path, payload) {
    const response = await authorized(path, payload ? {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'X-Aura-Preview': '1'},
      body: JSON.stringify(payload)
    } : {credentials: 'same-origin'});
    if (!response.headers.get('content-type')?.includes('application/json')) throw Error(text.offline);
    const data = await response.json();
    if (!response.ok) throw Error(data.error || text.offline);
    return data;
  }
  let uploadedSource = null, sourceInFlight = null;
  const sourceMemo=new WeakMap();
  async function originalSource(partial=false){
    if(!policy){const setup=await json('/api/products/'+config.productKey);policy=setup.policy;variants=setup.variants;checkoutEnabled=setup.checkoutEnabled===true;}
    const uploadIds=[];for(const file of files)uploadIds.push(await privateUpload(file));
    return (await json('/api/source-bundles',{uploadIds,contractHash:policy.contractHash,draft:partial})).id;
  }
  async function privateUpload(file) {
    if (sourceInFlight?.file === file) return sourceInFlight.promise;
    const pending = {file, promise: uploadSource(file)};
    sourceInFlight = pending;
    try { return await pending.promise; }
    finally { if (sourceInFlight === pending) sourceInFlight = null; }
  }
  async function uploadSource(file) {
    const owner = await session();
    if(sourceMemo.get(file)?.owner===owner)return sourceMemo.get(file).id;
    if (uploadedSource?.file === file && uploadedSource.owner === owner) return uploadedSource.id;
    const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
    const sha256 = Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
    const reserved = await json('/api/uploads', {name: file.name, type: file.type, size: file.size, sha256});
    const response = await authorized('/api/uploads/' + reserved.id, {method: 'PUT',
      headers: {'Content-Type': file.type, 'X-Aura-Preview': '1'}, body: file});
    if (!response.headers.get('content-type')?.includes('application/json')) throw Error(text.offline);
    const upload = await response.json();
    if (!response.ok || upload.status !== 'ready') throw Error(upload.error || text.fileError);
    uploadedSource = {file, owner, id: upload.id};sourceMemo.set(file,uploadedSource);
    return upload.id;
  }
  function uploadProperty(widget){
    return widget?.querySelector('[data-option-id="48ee08ce-12fc-4d38-8671-ba8a5ae73039"] input[type="hidden"][name^="properties["]') || widget?.querySelector('input[type="hidden"][name="properties[Upload your photo]"],input[type="hidden"][name="properties[Upload your image]"]');
  }
  function personalization() {
    if(config.completion){if(!window.AuraPersonalization)throw Error(text.setupError);return window.AuraPersonalization.read(section,policy);}
    if (config.productKey === 'birthday') {
      const input=section.querySelector('.po-productPageOptions-root input[type="date"], .po-productPageOptions-root input[placeholder="MM/DD/YYYY (e.g., 12/25/2025)"]');
      const value=window.AuraBirthday.normalizeDate(input?.value || '');
      return {date:value};
    }
    const widget = findUploadWidget();
    const value = widget?.querySelector(config.nameSelector || 'input[name="properties[Pet name]"]')?.value?.trim();
    if (policy?.personalization?.name?.required && !value) throw Error(text.nameRequired);
    return value && policy?.personalization?.name ? {name: value} : {};
  }
  function draw() {
    const selected = variant();
    if (!image || !selected) return;
    window.AuraVariant.draw(canvas.getContext('2d'), image, selected, policy?.cropFocal || [.5, 0], 'contain');
    approve.disabled = busy || cartBusy;
    updatePurchaseLabel();
    syncRoom();
  }
  function updatePurchaseLabel() {
    const selected = variant();
    finishOptions.hidden = !image;
    const price = form.querySelector('section-store--atc-price')?.textContent?.trim();
    const summaryLabel = selected ? [selected.options['Frame Style'], selected.options['Frame Color'], selected.options.Size, price].filter(Boolean).join(' · ') : '';
    if (selectionCopy.textContent !== summaryLabel) selectionCopy.textContent = summaryLabel;
    if (!image || busy || cartBusy) return;
    const label = cartAdded === selected?.id ? 'View cart' : text.approve + (price ? ' — ' + price : '');
    if (approve.textContent !== label) approve.textContent = label;
  }
  function placeOptions() {
    // Move the original app widget intact so its listeners and variant binding survive.
    const widget = section.querySelector('.globo-swatch-product-detail');
    if (widget && widget.parentElement !== optionsSlot) optionsSlot.prepend(widget);
    if (finishOptions.parentElement !== optionsSlot) optionsSlot.append(finishOptions);
    const uploadWidget = findUploadWidget();
    if (uploadWidget && !optionsSlot.contains(uploadWidget) && (optionsSlot.parentElement !== uploadWidget.parentElement || optionsSlot.nextElementSibling !== uploadWidget)) uploadWidget.before(optionsSlot);
  }
  function roomGuide() { return document.querySelector('aura-room-guide'); }
  function renderWall(size) {
    const source = image || handoffImage, selected = variant();
    if (!source || !selected) return '';
    const key = [proof?.id || 'phone', size || selected.options.Size].join(':');
    if (key === wallRenderKey) return wallRenderURL;
    const art = document.createElement('canvas');
    window.AuraVariant.draw(art.getContext('2d'), source, {...selected,options:{...selected.options,Size:size || selected.options.Size}}, policy?.cropFocal || [.5,0], 'contain');
    wallRenderKey = key;
    return wallRenderURL = art.toDataURL('image/jpeg', .82);
  }
  function syncRoom() {
    if (!image && !handoffImage) return;
    const guide = roomGuide();
    if (!guide?.setCustomArtwork) return;
    guide.ensureInitialized();
    const size = (draftVariant() || variant())?.options.Size;
    if (size && guide.state && guide.sizes.includes(size)) guide.state.size = size;
    guide.setCustomArtwork({proofId:proof?.id || 'phone',token:wallToken,render:renderWall});
    guide.querySelector('aura-wall-preview')?.queuePurchaseAR?.();
  }
  async function refreshWallToken() {
    if (!proof) return;
    const id = proof.id;
    const room = await json('/api/room-views',{proofId:id});
    if (proof?.id !== id) return;
    wallToken = room.token; syncRoom();
  }
  mount.refreshWallToken = refreshWallToken;
  let draftTimer = null, draftQueue = Promise.resolve();
  function draftFields() {
    return Array.from(section.querySelectorAll('[data-option-id]')).flatMap(option => {
      const input = option.querySelector('input[type="text"],input[placeholder="MM/DD/YYYY (e.g., 12/25/2025)"],input[type="number"],input[type="date"],input[type="time"],textarea,select');
      return input ? [{option: option.getAttribute('data-option-id'), value: input.value}] : [];
    });
  }
  function draftVariant() {
    const values = ['0','1','2'].map(index => section.querySelector('.swatch--gl[data-option-index="' + index + '"] input:checked')?.value);
    return values.every(Boolean) ? variants.find(v => ['Frame Style','Frame Color','Size'].every((name,index) => v.options[name] === values[index])) : variant();
  }
  mount.wallOptions = () => draftVariant()?.options;
  async function draftRequest(method, body) {
    const response = await authorized('/api/draft', {method,
      keepalive: method !== 'GET',
      ...(body ? {headers:{'Content-Type':'application/json','X-Aura-Preview':'1'},body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw Error(data.error || 'Your artwork could not be saved. Please keep this tab open.');
    return data;
  }
  function rememberDraft(draft) {
    savedDraft = draft; draftVersion = draft?.version || 0;
    try {
      if (draft) localStorage.setItem(draftKey, JSON.stringify({token:sessionToken,expiresAt:draft.expiresAt}));
      else localStorage.removeItem(draftKey);
    } catch (_) { throw Error('Saving on this browser is unavailable. Please keep this tab open.'); }
  }
  function scheduleDraftSave() {
    if (!draftStorage || restoringDraft || offeringDraft) return;
    clearTimeout(draftTimer);
    if (files.length) saveStatus.textContent = 'Saving your artwork…';
    draftTimer = setTimeout(() => saveDraftNow(), 300);
  }
  function saveDraftNow() {
    if (!draftStorage || restoringDraft || offeringDraft) return Promise.resolve();
    clearTimeout(draftTimer);
    const run = async () => {
      const file = files[0], captured = revision;
      if (!file && !config.originalLayout) {
        if (draftVersion) { await draftRequest('DELETE', {version:draftVersion}); rememberDraft(null); }
        saveStatus.textContent = ''; return;
      }
      saveStatus.textContent = 'Saving your artwork…';
      const uploadId = config.originalLayout?await originalSource(true):await privateUpload(file);
      if (captured !== revision || files[0] !== file) return;
      const selected = draftVariant();
      if (!selected) return;
      const data = await draftRequest('PUT', {version:draftVersion, productHandle:config.handle,
        uploadId, variantId:String(selected.id), proofId:proof?.id || null,
        pendingId:submission?.id && submission.id !== proof?.id ? submission.id : null, request:prompt.value.trim(), fields:draftFields()});
      rememberDraft(data.draft);
      saveStatus.textContent = '';
    };
    const next = draftQueue.then(run);
    draftQueue = next.catch(error => { saveStatus.textContent = error.message; });
    return draftQueue;
  }
  async function waitUntil(check, timeout = 45000) {
    const end = Date.now() + timeout;
    while (!check()) {
      if (Date.now() > end) throw Error('Your photo is taking longer to load. Please try Continue again.');
      await new Promise(resolve => setTimeout(resolve, 250));
    }
  }
  function setDraftOffer(value) {
    offeringDraft = value;
    resumeBox.hidden = !value;
    mount.setAttribute('data-draft-offer', String(value));
    create.hidden = value || !!image;
  }
  async function currentArtworkLayout(job){
    if(job?.layoutRepairAvailable!==true)return job;
    lock(true);create.textContent='Updating your artwork lettering…';
    let repaired=await json('/api/previews/'+job.id+'/recover',{});
    const end=Date.now()+60000;
    while(['queued','generating'].includes(repaired.status)){
      if(Date.now()>end)throw Error('Your saved artwork is still being updated. Please use Continue again.');
      await new Promise(resolve=>setTimeout(resolve,1200));
      repaired=await json('/api/previews/'+repaired.id);
    }
    if(repaired.status!=='ready')throw Error(repaired.error||text.failed);
    return repaired;
  }
  continueDraft.addEventListener('click', async () => {
    if (!savedDraft || restoringDraft) return;
    const draft = savedDraft;
    restoringDraft = true;
    continueDraft.disabled = startOver.disabled = true;
    continueDraft.textContent = 'Restoring your artwork…';
    status.textContent = '';
    try {
      const setup = await json('/api/products/' + config.productKey);
      if (setup.policy.handle !== config.handle || !(setup.policy.contractHash === draft.contractHash || (config.productKey === 'birthday' && setup.policy.legacyContractHashes?.includes(draft.contractHash)))) throw Error('This product has changed. Please start over to create a new preview.');
      policy = setup.policy; variants = setup.variants; checkoutEnabled = setup.checkoutEnabled === true;
      await waitUntil(() => section.querySelector('.po-productPageOptions-root input[type="file"]'));
      if(config.originalLayout){
        const loaded=[];
        for(const source of draft.sources||[]){const response=await authorized('/api/uploads/'+source.id+'/original');if(!response.ok)throw Error('An original photo could not be restored.');const file=new File([await response.blob()],source.name,{type:source.type});loaded.push(file);sourceMemo.set(file,{owner:sessionToken,id:source.id});}
        files=loaded;showFiles();
      }else{
      const original = await authorized('/api/uploads/' + draft.uploadId + '/original');
      if (!original.ok) throw Error('Your saved photo is unavailable. Please start over and upload it again.');
      const file = new File([await original.blob()], draft.originalName, {type:draft.originalType});
      const widget = findUploadWidget();
      widget.querySelectorAll('.po-fileUpload-uploadRemove').forEach(button => button.click());
      await waitUntil(() => !widget.querySelector('.po-fileUpload-uploadItem'));
      const input = widget.querySelector('input[type="file"]'), transfer = new DataTransfer();
      transfer.items.add(file); input.files = transfer.files;
      input.dispatchEvent(new Event('change', {bubbles:true}));
      uploadedSource = {file,owner:sessionToken,id:draft.uploadId};
      await waitUntil(() => {
        if (config.standaloneUpload) return files[0] === file;
        const current = findUploadWidget();
        const linked = uploadProperty(current);
        return current?.querySelectorAll('.po-fileUpload-uploadItem').length === 1 && !!linked?.value && !current.querySelector('[role="status"]');
      });
      }
      for (const field of draft.fields) {
        const option = Array.from(section.querySelectorAll('[data-option-id]')).find(el => el.getAttribute('data-option-id') === field.option);
        const input = option?.querySelector('input[type="text"],input[placeholder="MM/DD/YYYY (e.g., 12/25/2025)"],input[type="number"],input[type="date"],input[type="time"],textarea,select');
        if (input) {
          const setter = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(input), 'value')?.set;
          if (setter) setter.call(input, field.value); else input.value = field.value;
          input.dispatchEvent(new Event('input',{bubbles:true})); input.dispatchEvent(new Event('change',{bubbles:true}));
        }
      }
      const selected = variants.find(v => String(v.id) === draft.variantId);
      if (!selected) throw Error('This saved size is unavailable. Please start over.');
      prompt.value = draft.request;
      let job = draft.pendingId ? await json('/api/previews/' + draft.pendingId) : null;
      if(job?.status==='failed'&&job.artifactRecoverable===true)job=await json('/api/previews/'+job.id+'/recover',{});
      if (job && ['queued','generating'].includes(job.status)) {
        setDraftOffer(false); lock(true);
        const end = Date.now() + 240000;
        while (['queued','generating'].includes(job.status)) {
          showPhase(job);
          if (Date.now() > end) throw Error('Your preview is still processing. Use Continue to check it without generating again.');
          await new Promise(resolve => setTimeout(resolve,1500));
          job = await json('/api/previews/' + job.id);
        }
      }
      if ((!job || job.status !== 'ready') && draft.proofId) job = await json('/api/previews/' + draft.proofId);
      job=await currentArtworkLayout(job);
      if (job?.status === 'ready') {
        const response = await authorized('/api/previews/' + job.id + '/image');
        if (!response.ok) throw Error('Your preview could not be restored. Please try Continue again.');
        const url = URL.createObjectURL(await response.blob()), output = new Image();
        try { output.src=url; await output.decode(); } finally { URL.revokeObjectURL(url); }
        proof=job; image=output; submission=null; cartAdded=false; wallRenderKey='';
        results.hidden=false; optionsSlot.hidden=true;
      } else if (job?.status === 'failed') status.textContent = job.error || text.failed;
      for (const [name,value] of Object.entries(selected.options)) {
        const index = {'Frame Style':0,'Frame Color':1,Size:2}[name];
        const group = section.querySelector('.swatch--gl[data-option-index="' + index + '"]');
        const radio = Array.from(group?.querySelectorAll('input[type="radio"]') || []).find(el => el.value === value);
        if (radio && !radio.checked) {
          const label = radio.closest('li')?.querySelector('label');
          (label || radio).click();
          await new Promise(resolve => setTimeout(resolve, 350));
        }
      }
      await waitUntil(() => String(variant()?.id) === draft.variantId && String(draftVariant()?.id) === draft.variantId, 10000);
      // Globo can retain the first variant's URL after scripted label changes.
      // Only update the URL after its native purchase form and checked controls agree.
      if (typeof history !== 'undefined' && location.href) {
        const restoredUrl = new URL(location.href);
        restoredUrl.searchParams.set('variant', draft.variantId);
        history.replaceState(history.state, '', restoredUrl.href);
      }
      if (proof && image) {
        try {
          const cart = await cartSnapshot();
          if (cart.items?.some(item => String(item.variant_id) === draft.variantId && item.properties?.['Artwork reference'] === proof.id && item.properties?.['_Aura Receipt'])) cartAdded = draft.variantId;
        } catch (_) { /* A cart read failure must not block restoring artwork. */ }
      }
      draw(); if (image) refreshWallToken().catch(() => {});
      setDraftOffer(false);
      saveStatus.textContent = '';
    } catch (error) {
      status.textContent = error.message;
      setDraftOffer(true);
    } finally {
      restoringDraft=false; lock(false);
      if(image){approve.disabled=cartBusy;updatePurchaseLabel();}
      if (offeringDraft) create.hidden=true;
      continueDraft.disabled=startOver.disabled=false;
      continueDraft.textContent='Continue your artwork';
      syncUploadControl();
      if (!offeringDraft) scheduleDraftSave();
    }
  });
  startOver.addEventListener('click', async () => {
    if (restoringDraft) return;
    continueDraft.disabled=startOver.disabled=true;
    try {
      await draftQueue;
      await draftRequest('DELETE',{version:draftVersion});
      rememberDraft(null); setDraftOffer(false);
      invalidate(); files=[]; uploadedSource=null; prompt.value='';
      section.querySelectorAll('.po-fileUpload-uploadRemove').forEach(button => button.click());
      showFiles(); saveStatus.textContent='';
    } catch(error) { status.textContent=error.message; }
    finally { continueDraft.disabled=startOver.disabled=false; }
  });
  async function findSavedDraft() {
    if (!draftStorage || !validEndpoint) return;
    let saved;
    try { saved=JSON.parse(localStorage.getItem(draftKey) || 'null'); } catch (_) {}
    if (!saved || saved.expiresAt <= Date.now() || !/^[A-Za-z0-9_-]{43}$/.test(saved.token || '')) {
      try { localStorage.removeItem(draftKey); } catch (_) {} return;
    }
    sessionToken=saved.token;
    try { sessionStorage.setItem(sessionKey,sessionToken); } catch (_) {}
    setDraftOffer(true); continueDraft.disabled=startOver.disabled=true;
    resumeTitle.textContent='Loading your saved artwork…';
    try {
      const data=await draftRequest('GET');
      rememberDraft(data.draft);
      if (!data.draft) setDraftOffer(false);
    } catch(error) {
      setDraftOffer(false); saveStatus.textContent=error.message;
    } finally {
      resumeTitle.textContent='Your saved artwork';
      continueDraft.disabled=startOver.disabled=false;
    }
  }
  document.addEventListener('variant:update', scheduleDraftSave);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') saveDraftNow(); });
  window.addEventListener?.('pagehide', () => saveDraftNow());
  async function generate(edit) {
    if (busy || replacingPhoto || restoringDraft || offeringDraft) return;
    if (files.length !== (config.originalLayout?config.photoCount:1)) { status.textContent = text.photoRequired; return; }
    const widget = findUploadWidget();
    const items = widget?.querySelectorAll('.po-fileUpload-uploadItem');
    const linked = uploadProperty(widget);
    if (items?.length > 1) { status.textContent = text.fileError; return; }
    if (linked && (!linked.value || items?.length !== 1)) { status.textContent = text.uploading; return; }
    if (!validEndpoint) { status.textContent = text.offline; return; }
    const token = revision;
    lock(true);
    if (edit && typeof mount.scrollIntoView === 'function') {
      const scroll = () => mount.scrollIntoView({behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      if (typeof requestAnimationFrame === 'function') requestAnimationFrame(scroll);
      else scroll();
    }
    status.textContent = '';
    try {
      const setup = await json('/api/products/' + config.productKey);
      policy = setup.policy;
      checkoutEnabled = setup.checkoutEnabled === true;
      if (policy.handle !== config.handle) throw Error(text.setupError);
      variants = setup.variants;
      if (!variant()) throw Error(text.variantRequired);
      const fields = personalization();
      const request = edit ? prompt.value.trim() : '';
      if (edit && !request && config.productKey !== 'birthday' && !config.originalLayout) throw Error(text.prompt);
      const source = config.originalLayout?{uploadId:await originalSource(),cropSettings:window.AuraOriginal.getCrops(files)}:setup.transport === 'r2-stream-v1'
        ? {uploadId: await privateUpload(files[0])}
        : {photos: await Promise.all(files.map(readFile)), photoNames: files.map(f => f.name)};
      if (token !== revision) throw Error(text.changed);
      const payload = {
        productId: config.productKey, productHandle: config.handle,
        contractHash: policy.contractHash, ...source,
        personalization: fields, request, editMode: 'full', previousProofId: edit ? proof?.id : null
      };
      const signature = JSON.stringify(payload);
      if (!submission || submission.signature !== signature) submission = {signature, requestId: crypto.randomUUID()};
      let job;
      if (submission.id) {
        job=await json('/api/previews/'+submission.id);
        // This branch runs only after the customer explicitly clicks Create again.
        // The backend permits only saved-PNG postprocessing recovery, never another paid API call.
        if(job.status==='failed'&&job.artifactRecoverable===true)job=await json('/api/previews/'+job.id+'/recover',{});
      }
      else if(config.originalLayout){
        const layoutPNG=await window.AuraOriginal.render(files,fields,policy);if(token!==revision)throw Error(text.changed);
        job=await json('/api/layout-previews',{...payload,request:'',layoutPNG,requestId:submission.requestId});
      }else if(config.productKey==='birthday'){
        const layoutPNG=await window.AuraBirthday.render(files[0],fields.date);
        if(token!==revision)throw Error(text.changed);
        job=await json('/api/layout-previews',{...payload,request:'',layoutPNG,requestId:submission.requestId});
      }else job=await json('/api/previews',{...payload,requestId:submission.requestId});
      submission.id = job.id;
      await saveDraftNow();
      showPhase(job);
      const deadline = Date.now() + 240000;
      while (['queued', 'generating'].includes(job.status)) {
        if (token !== revision) throw Error(text.changed);
        if (Date.now() > deadline) throw Error(text.processing);
        await new Promise(resolve => setTimeout(resolve, 1500));
        job = await json('/api/previews/' + job.id);
        showPhase(job);
      }
      job=await currentArtworkLayout(job);
      if (job.status !== 'ready') throw Error(job.error || text.failed);
      create.textContent = 'Finishing your preview…';
      const output = new Image();
      const response = await authorized('/api/previews/' + job.id + '/image');
      if (!response.ok || !response.headers.get('content-type')?.includes('image/jpeg')) throw Error(text.failed);
      const previewUrl = URL.createObjectURL(await response.blob());
      try { output.src = previewUrl; await output.decode(); }
      finally { URL.revokeObjectURL(previewUrl); }
      if (token !== revision) throw Error(text.changed);
      proof = job;
      image = output;
      cartAdded = false; wallRenderKey = '';
      optionsSlot.hidden = true;
      draw();
      refreshWallToken().catch(() => {});
      results.hidden = false;
      status.textContent = checkoutEnabled ? '' : text.checkoutHeld;
    } catch (error) {
      status.textContent = error.message;
    } finally { lock(false); scheduleDraftSave(); if (image) { approve.disabled = cartBusy; updatePurchaseLabel(); refine.open=false; if (typeof requestAnimationFrame === 'function') requestAnimationFrame(() => results.scrollIntoView({behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})); } }
  }
  document.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof Element) || !section.contains(target)) return;
    if (target.matches('.po-productPageOptions-root input[type="file"]')) {
      invalidate();
      const chosen=Array.from(target.files||[]);
      files=config.originalLayout&&files.length<config.photoCount?[...files,...chosen].slice(0,config.photoCount):chosen;
      if (files.length > (config.originalLayout?config.photoCount:1) || files.some(f => !['image/jpeg', 'image/png', 'image/webp'].includes(f.type) || f.size > 20 * 1024 * 1024)) {
        files = [];
        status.textContent = text.fileError;
      }
      showFiles();
    } else if (target.closest('.po-productPageOptions-root,.aep-personalization,.aep-crop-controls')) {
      invalidate();
    } else {
      setTimeout(draw, 150);
    }
    scheduleDraftSave();
  }, true);
  document.addEventListener('input', event => {
    if (event.target instanceof Element && event.target.closest('.po-productPageOptions-root,.aep-personalization,.aep-crop-controls') && section.contains(event.target)) invalidate();
    if (event.target instanceof Element && section.contains(event.target)) scheduleDraftSave();
  }, true);
  document.addEventListener('submit', event => {
    if (event.target === form) {
      if (cartPermit && !cartPermit.submitted && Date.now() < cartPermit.expires && variant()?.id === cartPermit.variantId) { cartPermit.submitted = true; return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      status.textContent = text.checkoutHeld;
    }
  }, true);
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest('sticky-add-to-cart') || (target?.closest('button[name="add"]') && section.contains(target))) {
      if (cartPermit && !cartPermit.clicked && Date.now() < cartPermit.expires && variant()?.id === cartPermit.variantId) { cartPermit.clicked = true; return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      status.textContent = text.checkoutHeld;
    }
    if (target?.closest('.po-productPageOptions-root') && !target.closest('[data-upload-field],.aep-change-photo,.aep-photo-tips-trigger')) {
      const removing = target.closest('.po-fileUpload-uploadRemove');
      if (removing && files.length) {
        invalidate();
        files = [];
        showFiles();
        scheduleDraftSave();
      }
    }
  }, true);
  document.addEventListener('variant:update', draw);
  async function cartSnapshot() {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw Error('Your cart could not be checked.');
    return response.json();
  }
  function openCart() {
    const cartUrl = (window.Shopify?.routes?.root || '/') + 'cart';
    const visibleCart = () => {
      const roots = [document, ...Array.from(document.querySelectorAll('section-store--cart-block')).map(el => el.shadowRoot).filter(Boolean)];
      return roots.some(root => Array.from(root.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"][aria-hidden="false"]'))
        .some(el => (/cart/i.test(el.getAttribute('aria-label') || '') || el.closest('cart-drawer-component')) && el.getClientRects().length > 0 && (!cartAdded || !/your cart is empty/i.test(el.innerText || ''))));
    };
    if (visibleCart()) return;
    // Use the storefront trigger so the active cart app receives its click.
    const opener = document.querySelector('header [data-testid="cart-drawer-trigger"], header button[aria-label="Cart"], header a[aria-label="Cart"]');
    try {
      if (opener) opener.click();
      else {
        const drawer = document.querySelector('cart-drawer-component');
        if (typeof drawer?.open === 'function') drawer.open();
        else { window.location.assign(cartUrl); return; }
      }
    } catch (_) { window.location.assign(cartUrl); return; }
    // An installed cart app can intercept the native drawer; verify it opened.
    setTimeout(() => { if (!visibleCart()) window.location.assign(cartUrl); }, 1200);
  }
  approve.addEventListener('click', async () => {
    if (cartAdded === variant()?.id) { openCart(); return; }
    if (cartBusy || busy) return;
    if (!proof || !image) { status.textContent = 'Please create your artwork preview first.'; return; }
    const selected = variant(), capturedRevision = revision, proofId = proof.id;
    if (!selected) { status.textContent = text.variantRequired; return; }
    if (!config.originalLayout && !form.reportValidity()) { status.textContent = 'Please complete the required details above.'; return; }
    cartBusy = true; approve.disabled = true; approve.textContent = 'Adding…';
    let submitted = false;
    try {
      if (!checkoutEnabled) {
        const setup = await json('/api/products/' + config.productKey);
        checkoutEnabled = setup.checkoutEnabled === true;
        if (!checkoutEnabled) throw Error('Ordering is temporarily unavailable. Please try again shortly.');
      }
      const selection = await json('/api/selections', {proofId,variantId:String(selected.id)});
      if (capturedRevision !== revision || proof?.id !== proofId || String(variant()?.id) !== String(selection.variantId)) throw Error(text.changed);
      const found = cart => cart.items?.find(item => String(item.variant_id) === String(selection.variantId) && item.properties?.['_Aura Selection'] === selection.id && item.properties?.['_Aura Receipt'] === selection.properties['_Aura Receipt']);
      if (found(await cartSnapshot())) { cartAdded=selected.id; openCart(); return; }
      for (const [key,value] of Object.entries(selection.properties)) {
        const name = 'properties[' + key + ']';
        let input = Array.from(form.querySelectorAll('input[type="hidden"]')).find(el => el.name === name);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
        input.value = value;
      }
      if(config.originalLayout){
        const properties={...selection.properties};for(const [key,value]of Object.entries(personalization()))properties[policy.personalization[key].label]=value;
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:selection.variantId,quantity:1,properties}]})});
        if(!response.ok)throw Error('The artwork could not be added. Please check your cart before retrying.');
        if(!found(await cartSnapshot()))throw Error('Please check your cart before trying again.');
        cartAdded=selected.id;openCart();return;
      }
      const native = form.querySelector('button[name="add"]');
      if (!native || native.disabled) throw Error('This option is unavailable. Please choose another size.');
      cartPermit = {variantId:selected.id,expires:Date.now()+15000,clicked:false,submitted:false};
      submitted = true;
      native.click();
      for (let attempt=0;attempt<8;attempt++) {
        await new Promise(resolve=>setTimeout(resolve,1500));
        if (found(await cartSnapshot())) { cartPermit=null; cartAdded=selected.id; status.textContent=''; openCart(); return; }
      }
      throw Error('Please check your cart before trying again. No automatic retry was made.');
    } catch(error) { status.textContent=error.message; }
    finally { cartPermit=null; cartBusy=false; draw(); }
  });
  create.addEventListener('click', () => generate(false));
  regenerate.addEventListener('click', () => generate(true));
  if (!validEndpoint) {
    const note = document.createElement('p');
    note.className = 'aep-pilot';
    note.textContent = text.pilot;
    mount.append(note);
  }
  new MutationObserver(() => {
    syncUploadControl();
    placeOptions();
    const current = document.querySelector('main form[action$="/cart/add"]');
    if (!current) return;
    const changed = current !== form;
    if (changed) { form = current; section = form.closest('.shopify-section') || document.querySelector('main'); }
    if (!mount.isConnected) form.parentElement.insertBefore(mount, form);
    if (changed) draw();
    updatePurchaseLabel();
  }).observe(document.querySelector('main'), {childList: true, characterData: true, subtree: true});
  syncUploadControl();
  placeOptions();
  if(config.completion)window.AuraPersonalization?.mount(config,section,mount,create);
  findSavedDraft();
  // A QR only carries a short-lived compressed image capability, never the guest session.
  const handoff = new URLSearchParams(location.hash.slice(1)).get('aw-preview');
  if (/^[A-Za-z0-9_-]{32}$/.test(handoff || '')) {
    (async () => {
      try {
        const response = await fetch(endpoint + '/api/room-views/' + handoff,{credentials:'same-origin'});
        if (!response.ok || !response.headers.get('content-type')?.includes('image/jpeg')) return;
        const url = URL.createObjectURL(await response.blob()), output = new Image();
        try { output.src=url; await output.decode(); } finally { URL.revokeObjectURL(url); }
        handoffImage=output; wallToken=handoff; syncRoom();
        mount.setAttribute('data-artwork-ready', 'true');
        const wall=roomGuide()?.querySelector('aura-wall-preview');
        if (wall) wall.queuePurchaseAR();
      } catch(error) { status.textContent=error.message; }
    })();
  }
  return true;
  }
  if (!init()) {
    const pending = new MutationObserver(() => { if (init()) pending.disconnect(); });
    pending.observe(document.documentElement, {childList: true, subtree: true});
    setTimeout(() => pending.disconnect(), 20000);
  }
})();






